import CampaignIcon from "@mui/icons-material/Campaign";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PaymentsIcon from "@mui/icons-material/Payments";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import SchoolIcon from "@mui/icons-material/School";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

import {
  CandidateServicePath,
  CampaignTypes,
  CANDIDACIES,
  CANDIDACIES_PRELIMINARY,
  CANDIDACIES_REGULAR,
  CANDIDACIES_PAID,
  CANDIDACIES_HOSPITAL_CONTRACTS,
  CampaignSubTypes,
  PRELIMINARY,
  REGULAR,
  PAID,
  HOSPITAL_CONTRACTS,
  PREPARATORY_YEARS,
  COURSES,
  CANDIDACIES_COURSES,
  CURRICULUM_SELECTION_CAMPAIGN_APPLICATIONS,
  StudentServicePath,
} from "utils/constants";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";
import RedirectToCandidacyTab from "./RedirectToCandidacyTab";
import ListCandidates from "./List/List";
import ListPreparatoryYear from "./List/ListPreparatoryYear";
import ShowCandidate from "./Show/Show";
import CreateRegularCandidate from "./Create/CreateRegular";
import CreatePaidCandidate from "./Create/CreatePaid";
import ListCurriculumSelectionCampaignApplications from "components/LearningActivity/CurriculumSelectionCampaignApplications/List";

// Hidden resources (isMenu: false) — spread into app/resources.js so their list/show/create
// routes exist while CandidatesPage renders them as tabs. `tabKey` is explicit because every
// candidacy name ends in "candidacies", so the default key derivation would collide.
// Kept in its own module so Page.js can build the tabs from it without importing ./index.js
// (which imports Page.js — that would be a cycle).
export const candidateResources = [
  {
    isMenu: false,
    tenancies: [tenants.MU],
    tabKey: PRELIMINARY,
    icon: <CampaignIcon />,
    name: CandidateServicePath + CANDIDACIES_PRELIMINARY,
    title: "Предварителни кампании",
    list: <RedirectToCandidacyTab type={PRELIMINARY} />,
    tabList: <ListCandidates campaignSubType={CampaignSubTypes.Preliminary} />,
    show: <ShowCandidate />,
    showPermission: permissions.canPreviewCandidacies,
    permission: permissions.canPreviewCandidacies,
  },
  {
    isMenu: false,
    tenancies: [tenants.MU],
    tabKey: REGULAR,
    icon: <HowToRegIcon />,
    name: CandidateServicePath + CANDIDACIES_REGULAR,
    title: "Редовни кампании",
    list: <RedirectToCandidacyTab type={REGULAR} />,
    tabList: <ListCandidates campaignSubType={CampaignSubTypes.Regular} />,
    show: <ShowCandidate />,
    create: <CreateRegularCandidate />,
    showPermission: permissions.canPreviewCandidacies,
    permission: permissions.canPreviewCandidacies,
  },
  {
    isMenu: false,
    tenancies: [tenants.MU],
    tabKey: PAID,
    icon: <PaymentsIcon />,
    name: CandidateServicePath + CANDIDACIES_PAID,
    title: "Платени кампании",
    list: <RedirectToCandidacyTab type={PAID} />,
    tabList: <ListCandidates campaignSubType={CampaignSubTypes.Paid} />,
    show: <ShowCandidate />,
    create: <CreatePaidCandidate resource={CandidateServicePath + CANDIDACIES} />,
    showPermission: permissions.canPreviewCandidacies,
    permission: permissions.canPreviewCandidacies,
  },
  {
    isMenu: false,
    tenancies: [tenants.MU],
    tabKey: HOSPITAL_CONTRACTS,
    icon: <LocalHospitalIcon />,
    name: CandidateServicePath + CANDIDACIES_HOSPITAL_CONTRACTS,
    title: "Кампании с договор с болница",
    list: <RedirectToCandidacyTab type={HOSPITAL_CONTRACTS} />,
    tabList: <ListCandidates campaignSubType={CampaignSubTypes.HospitalContract} />,
    show: <ShowCandidate />,
    showPermission: permissions.canPreviewCandidacies,
    permission: permissions.canPreviewCandidacies,
  },
  // Its own permission, unlike the four above — TabsPage hides this tab from users who only
  // hold canPreviewCandidacies, and ./index.js accepts either permission for the page itself.
  {
    isMenu: false,
    tenancies: [tenants.MU],
    tabKey: PREPARATORY_YEARS,
    icon: <SchoolIcon />,
    name: CandidateServicePath + PREPARATORY_YEARS,
    title: "Подготвителна година",
    list: <RedirectToCandidacyTab type={PREPARATORY_YEARS} />,
    tabList: <ListPreparatoryYear />,
    permission: permissions.canPreviewPreparatoryYearCandidates,
  },
  {
    isMenu: false,
    tenancies: [tenants.MU],
    tabKey: COURSES,
    icon: <LocalLibraryIcon />,
    name: CandidateServicePath + CANDIDACIES_COURSES,
    title: "Подготвителни курсове",
    list: <RedirectToCandidacyTab type={COURSES} />,
    tabList: <ListCandidates campaignType={CampaignTypes.PreparatoryCourses} />,
    show: <ShowCandidate />,
    showPermission: permissions.canPreviewCandidacies,
    permission: permissions.canPreviewCandidacies,
  },
  {
    isMenu: false,
    tabKey: CURRICULUM_SELECTION_CAMPAIGN_APPLICATIONS,
    icon: <SwapHorizIcon />,
    name: StudentServicePath + CURRICULUM_SELECTION_CAMPAIGN_APPLICATIONS,
    title: "Избор на учебен план",
    list: <RedirectToCandidacyTab type={CURRICULUM_SELECTION_CAMPAIGN_APPLICATIONS} />,
    tabList: <ListCurriculumSelectionCampaignApplications />,
    permission: permissions.canPreviewCurriculumSelectionCampaigns,
  },
];
